import React from 'react';
import { Link } from 'react-router-dom';
import { blogCardPropTypes } from 'core/propTypes/componentProps';
import { all_routes } from 'core/data/routes/all_routes';
import ImageWithBaseApi from 'components/common/mediaRender/ImageWithBaseApi';

const BlogCard = ({
    image,
    title,
    author,
    tags,
    date,
    id,
    className = ''
}) => {
    return (
        <div className={`ltn__blog-item ltn__blog-item-3 ${className}`}>
            <div className="ltn__blog-img d-grid" >
                <Link to={all_routes.projectDetails + "/" + id}>
                    <ImageWithBaseApi src={image} alt={title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </Link>
            </div>
            <div className="ltn__blog-brief w-100  mt-0">
                <div className="ltn__blog-meta" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    <ul className="d-flex justify-content-between" style={{ gap: '15px' }}>
                        <li className="ltn__blog-author truncate-text me-0">
                            <Link to="#">
                                <i className="far fa-user" />{author}
                            </Link>
                        </li>
                        <li className="ltn__blog-tags" style={{ display: 'flex', gap: '5px' }}>
                            {tags?.map((tag, index) => (
                                <Link className="truncate-text" to={all_routes.projectDetails} key={index}>
                                    <i className="fas fa-tags" />{tag}
                                </Link>
                            ))}
                        </li>
                    </ul>
                </div>
                <h3 className="ltn__blog-title" style={{
                    display: '-webkit-box',
                    WebkitLineClamp: '1',
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    lineHeight: '1.5em',
                    maxHeight: '3em'
                }}>
                    <Link to={all_routes.projectDetails  + "/" + id}>{title}</Link>
                </h3>
                <div className="ltn__blog-meta-btn">
                    <div className="ltn__blog-meta">
                        <ul>
                            <li className="ltn__blog-date">
                                <i className="far fa-calendar-alt" />{date}
                            </li>
                        </ul>
                    </div>
                    <div className="ltn__blog-btn">
                        <Link to={all_routes.projectDetails  + "/" + id}>Ver Proyecto</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogCard;